import mapValues from 'lodash/mapValues';

// Renames `fromKey` to `toKey` on the target object in place. No-op when the
// target is missing or the key is absent. Used to alias metric keys across
// graph stats responses during the v1 → v2 engine rollout.
export function renameMetricKey(target, fromKey, toKey) {
  if (!target || !(fromKey in target)) return;
  target[toKey] = target[fromKey];
  delete target[fromKey];
}

export function selectGraphSeries(response, { brandId, channel, metric }) {
  const root = response?.data;
  // Shape A — channel-keyed top level (target shape). Use `!== undefined` so
  // an empty {} response is treated as "Shape A present, no data" and does
  // not silently fall through to Shape B.
  const shapeA = root?.[channel]?.metrics?.[metric]?.[channel];
  if (shapeA !== undefined) return shapeA;
  // TODO(sc-195103-cleanup): remove Shape B fallback once backend migration completes.
  return root?.[brandId]?.[channel]?.[metric];
}

export function selectChannelMetricsBag(response, { brandId, channel }) {
  const root = response?.data;
  // Shape A — channel-keyed top level (target shape)
  const shapeAMetrics = root?.[channel]?.metrics;
  if (shapeAMetrics) {
    return mapValues(shapeAMetrics, (perChannel) => perChannel?.[channel]);
  }
  // TODO(sc-195103-cleanup): remove Shape B fallback once backend migration completes.
  return root?.[brandId]?.[channel];
}

// Returns { <CHANNEL>: { <date>: value } } for a metric across all channels in
// the response, regardless of shape. Used by consumers that need to enumerate
// channels themselves (multi-channel charts).
export function selectChannelsForMetric(response, { brandId, metric }) {
  const root = response?.data;
  if (!root) return undefined;

  // Shape A — channel-keyed top level (target shape)
  const shapeA = {};
  Object.entries(root).forEach(([key, bucket]) => {
    if (key === String(brandId)) return;
    const series = bucket?.metrics?.[metric]?.[key];
    if (series !== undefined) shapeA[key] = series;
  });
  if (Object.keys(shapeA).length > 0) return shapeA;

  // TODO(sc-195103-cleanup): remove Shape B fallback once backend migration completes.
  return root[brandId]?.metrics?.[metric];
}
